const brFinancialReport = {
  financialReport: {
    title: 'Relatórios Financeiros',

    columns: {
      host: 'Host',
      issuer: 'Emitente',
      month: 'Mês',
      quinzena: 'Quinzena',
      customer: 'Cliente',
      year: 'Ano',
      total: 'Total',
      max_visit_date: 'Última visita',

      subscription_type: 'Tipo de assinatura',
      phone: 'Telefone',
      email: 'E-mail',
      city: 'Cidade',
      deleted_at: 'Excluído em',
      is_tester: 'Tester',
      balance: 'Saldo',
      max_created_at: 'Último movimento',

      totalNF: 'Total NF',
      invoiceDate: 'Data da nota',
      transferDate: 'Data da transferência',
      external_transfer_id: 'ID transferência',
      fileName: 'Arquivo',
      externalURL: 'URL',

      yearMonth: 'Ano/Mês',
      lastMovement: 'Último movimento',
      id: 'ID',
      cnpj: 'CNPJ',
      partner: 'Parceiro',
      serviceProvider: 'Prestador',
      cluster: 'Cluster',
      entradas: 'Entradas',
      saidas: 'Saídas',
      saldo: 'Saldo',

      contract_group_key: 'Índice',
      visit_year_month: 'Ano/Mês',
      max_visit_date_scheduled: 'Última visita agendada',
      real_estate_name: 'Imobiliária',
      real_estate_cnpj: 'CNPJ',
      real_estate_date_created: 'Criado em',
      real_estate_state: 'Estado',
      real_estate_city: 'Cidade',
      real_estate_address: 'Endereço',
      contract_subscription_type: 'Tipo de contrato',
      contract_is_active: 'Contrato ativo',
      contract_monthly_capacity: 'Capacidade mensal',
      contract_monthly_value: 'Valor diário',
      service_contract_area: 'Área (m²)',
      contract_start_date: 'Início contrato',
      contract_end_date: 'Fim contrato',
      agendamentos: 'Agendamentos',
      payment_amount: 'Pagamento',
      distinct_realty_code: 'Imóveis distintos',
      sum_area: 'Área total',
      meses_proporcional: 'Meses proporcional',

      contract_type: 'Tipo de contrato',
      start_date: 'Início',
      end_date: 'Vencimento',
      monthly_capacity: 'Volume mensal',
      monthly_value: 'Valor mensal',
    },
  },
}

export default brFinancialReport
